const getDefaultState = () => {
  return {
    ficheDeAnimateur: [],
  };
};
const state = getDefaultState();

const mutations = {
  SET_FICHES_DE_ANIMATEUR(state, payload) {
    state.ficheDeAnimateur = payload;
  },
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
  ADD_ONE_ITEM(state, payload) {
    state.ficheDeAnimateur.push(payload);
  },
};

const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },
  addOneItem({ commit }, item) {
    commit("ADD_ONE_ITEM", item);
    console.log("added to Vuex Fiche", item)
  },

  async get_fiche_of_animateur({ commit }, objet) {
    var start = this._vm
      .$moment(Date.now())
      .subtract(3, "months")
      .format("YYYY-MM-DD HH:mm:ss");
    var end = this._vm
      .$moment(Date.now())
      .add(3, "days")
      .format("YYYY-MM-DD HH:mm:ss");
    console.log("start fiches :", start);
    console.log("end fiches:", end);
    console.log("objet:", objet);
    // start requête

    commit("SET_FICHES_DE_ANIMATEUR", []);
    commit("RESET_STATE");
    commit("Loading/START_BUSY_STATE", "get_fiche_of_animateur GetAll", {
      root: true,
    });
    console.log(objet);
    let elems = [];
    await this._vm.$firebase
      .firestore()
      .collection("fiches")
      .where("id_responsable", "==", objet.userId)
      .where("programmes_id_programme", "==", objet.project.id)
      .where("date_insert_etape_effective", ">=", start)
      .where("date_insert_etape_effective", "<=", end)
      .get()
      .then(
        (snapshot) => {
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          if (!elems) {
            let text = "No Data Available";
            console.log(text);
            //start set snackbar
            let snack = {};
            snack.showSnackbar = true;
            snack.snackbarContent = text;
            commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
            //End set snackbar
            commit(
              "Loading/END_BUSY_STATE",
              "get_fiche_of_animateur No Data Available ",
              {
                root: true,
              }
            );
            return false;
          } else {
            commit("SET_FICHES_DE_ANIMATEUR", elems);
            commit("Loading/END_BUSY_STATE", "get_fiche_of_animateur ", {
              root: true,
            });
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });

          commit("Loading/END_BUSY_STATE", "get_fiche_of_animateur error", {
            root: true,
          });
        }
      );
  },
};

const getters = {
  FicheDeAnimateur: (state) => {
    return state.ficheDeAnimateur;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
